module.exports = __webpack_public_path__ + "static/media/wave-left-bottom.d252e71f.svg";